"use client"
import React from 'react';
import anime from "animejs"
import { useInView } from 'react-intersection-observer';

const Timeline = () =>{

    const { ref: text, inView: textIsVisible } = useInView({triggerOnce: true,});

    const { ref: date1, inView: date1IsVisible } = useInView({triggerOnce: true,});
    const { ref: date2, inView: date2IsVisible } = useInView({triggerOnce: true,});
    const { ref: date3, inView: date3IsVisible } = useInView({triggerOnce: true,});
    const { ref: date4, inView: date4IsVisible } = useInView({triggerOnce: true,});


    const timelineDetails = [
      {
        date: "2018",
        institution: "DAV Mogappair",
        desc: "I love what I do and as a fervent software developer, I thrive on challenges. I keep an active presence in the open-source community, with some of my popular projects having thousands of public downloads.",
      },
      {
        date: "2020",
        institution: "Maharishi Vidya Mandir",
        desc: "I love what I do and as a fervent software developer, I thrive on challenges. I keep an active presence in the open-source community, with some of my popular projects having thousands of public downloads.",
      },
      {
        date: "2023",
        institution: "Citi",
        desc: "I love what I do and as a fervent software developer, I thrive on challenges. I keep an active presence in the open-source community, with some of my popular projects having thousands of public downloads.",
      },
      {
        date: "2024",
        institution: "SSN College",
        desc: "I love what I do and as a fervent software developer, I thrive on challenges. I keep an active presence in the open-source community, with some of my popular projects having thousands of public downloads.",
      }
    ];



    
    if(textIsVisible){
    anime({
            targets: '#timeline path',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 800,
            delay: function(el, i) { return i * 50 },
            direction: 'alternate',
            loop: false,
        });
    }

      if(date1IsVisible){
        anime({
            targets: '#line1 path',
            fill:'#00FFFF',
            easing: 'easeInOutSine',
            duration: 800,
            delay: function(el, i) { return i * 20 },
            direction: 'alternate',
            loop: false,
          });
      }
    //   {timelineDetails.map(function(data) {
    //     return(<>
    //                         <div ref={date1} className={`flex flex-col justify-center items-center pb-2 ${date1IsVisible ? "slide" : ''}`}>
    //                         <p className="text-gray-400 text-2xl font-bold">{data.date}</p>
    //                         <p className="text-gray-400 text-2xl font-bold">{data.institution}</p>
    //                         {/* <div className='w-[10px] h-[10px] rounded-full bg-cyan-500 m-3'></div> */}
    //                         {/* <div className='flex justify-center items-center border-solid border-2 border-gray-600 text-gray-400 w-[500px] h-fit bg-opacity-10 bg-blur-md bg-gray-400 backdrop-filter backdrop-blur-md rounded-md p-3'>
    //                             <p className='text-center text-sm'>I love what I do and as a fervent software developer, I thrive on challenges. I keep an active presence in the open-source community, with some of my popular projects having thousands of public downloads.</p>
    //                         </div> */}
    //                     </div>
    //                     <svg width="17" height="158" viewBox="0 0 17 158" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                         <path d="M8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0ZM7 8L7 158H10L10 8H7Z" fill="#00FFFF"/>
    //                     </svg>

    //                     </>)
    // })}

    return(
        <div id="timelineSection" className="flex flex-col md:flex-row w-screen justify-center items-center p-20 md:p-0 my-8">

            <div className='md:h-screen w-fit flex justify-center items-center md:m-0'>
                <svg ref={text} id="timeline" width="325" height="48" viewBox="0 0 325 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M287.85 1.8H286.85V2.8V45.8V46.8H287.85H322.413H323.413V45.8V31.5522V30.5522H322.413H320.992V30.5254V17.9194H322.48H323.48V16.9194V2.8V1.8H322.48H287.85ZM302.316 34.7612V35.7612H303.316H318.051V41.591H292.212V7.00895H318.118V12.7104H303.316H302.316V13.7104V20.3851V21.3851H303.316H315.63V26.3164H303.316H302.316V27.3164V34.7612Z" stroke="#00FFFF" stroke-width="2"/>
                    <path d="M256.403 46.8H257.403V45.8V36.4645L264.1 46.3604L264.397 46.8H264.928H281.552H282.552V45.8V2.8V1.8H281.552H263.666H262.666V2.8V12.1936L255.814 2.23326L255.516 1.8H254.99H238.449H237.449V2.8V45.8V46.8H238.449H256.403ZM252.041 27.8298V41.591H242.812V7.00895H252.65L262.506 21.3369L262.506 21.3369L262.51 21.3428C262.623 21.5046 262.734 21.6645 262.843 21.8223C264.192 23.7774 265.223 25.4227 265.946 26.7639L266.229 27.2895H266.826H267.028H268.028V26.2895V7.00895H277.19V41.591H267.29L257.164 26.6276L257.164 26.6276L257.158 26.6183L254.132 22.2541L253.834 21.8239H253.31H253.108H252.122L252.109 22.8104L252.041 27.8164L252.041 27.8164V27.8298Z" stroke="#00FFFF" stroke-width="2"/>
                    <path d="M212.814 1.8H211.814V2.8V45.8V46.8H212.814H231.643H232.643V45.8V2.8V1.8H231.643H212.814ZM217.177 7.00895H227.28V41.591H217.177V7.00895Z" stroke="#00FFFF" stroke-width="2"/>
                    <path d="M173.908 1.8H172.908V2.8V45.8V46.8H173.908H208.404H209.404V45.8V30.9104V29.9104H208.404H193.737V2.8V1.8H192.737H173.908ZM188.374 34.1194V35.1194H189.374H204.042V41.591H178.271V7.00895H188.374V34.1194Z" stroke="#00FFFF" stroke-width="2"/>
                    <path d="M134.28 1.8H133.28V2.8V45.8V46.8H134.28H168.843H169.843V45.8V31.5522V30.5522H168.843H167.422V30.5254V17.9194H168.91H169.91V16.9194V2.8V1.8H168.91H134.28ZM148.746 34.7612V35.7612H149.746H164.481V41.591H138.642V7.00895H164.548V12.7104H149.746H148.746V13.7104V20.3851V21.3851H149.746H162.06V26.3164H149.746H148.746V27.3164V34.7612Z" stroke="#00FFFF" stroke-width="2"/>
                    <path d="M128.821 46.8H129.864L129.82 45.7578L128.002 2.75776L127.962 1.8H127.003H101.353H100.532L100.373 2.60545L100.032 4.32008L99.6726 2.5957L99.5065 1.8H98.6936H73.48H72.5231L72.4809 2.75592L70.5839 45.7559L70.5379 46.8H71.583H89.7058H90.6715L90.6859 46.3863L90.7754 46.8H91.5822H108.318H109.113L109.292 46.0257L109.725 44.1559L109.799 45.8433L109.84 46.8H110.798H128.821ZM90.7219 21.1175C89.7847 17.1565 89.1326 14.4938 88.7684 13.1446L88.764 13.1285L88.5642 12.3895H87.7987H87.597H86.6773L86.6004 13.306L86.5961 13.3577C86.4423 15.2152 86.3061 18.0352 86.1865 21.8052L86.1845 21.8689L87.0934 21.8976L86.1845 21.8689C86.1653 22.4767 86.1466 23.1093 86.1282 23.7668C86.0887 24.0621 86.069 24.4375 86.062 24.8719C86.0601 24.9902 86.0591 25.1146 86.059 25.2451L85.4881 41.591H76.1348L77.6604 7.00895H95.1223L98.2493 21.9927L99.0546 26.22L101.002 26.2938C101.368 24.9403 101.71 23.4407 102.027 21.7965C102.027 21.7957 102.027 21.7948 102.027 21.794L104.96 7.00895H122.815L124.277 41.591H114.981L114.149 22.405C114.149 22.4035 114.149 22.4019 114.149 22.4004C114.137 22.0625 114.126 21.7316 114.114 21.4076C113.989 17.9501 113.844 15.2667 113.68 13.366L113.675 13.3026L113.595 12.3895H112.679H112.477H111.754L111.528 13.0756L111.522 13.0925L111.522 13.0926C110.967 14.7747 110.332 17.3389 109.615 20.7576L109.281 22.3518L104.823 41.591H95.1281L91.3999 24.3516L91.3986 24.3453L90.7275 21.1427L90.7248 21.1301L90.7219 21.1175Z" stroke="#00FFFF" stroke-width="2"/>
                    <path d="M46.8995 1.8H45.8995V2.8V45.8V46.8H46.8995H65.7276H66.7276V45.8V2.8V1.8H65.7276H46.8995ZM51.2616 7.00895H61.3654V41.591H51.2616V7.00895Z" stroke="#00FFFF" stroke-width="2"/>
                    <path d="M32.1343 46.8H33.1343V45.8V18.2403H42.9605H43.9605V17.2403V2.8V1.8H42.9605H2.47998H1.47998V2.8V17.2403V18.2403H2.47998H12.3062V45.8V46.8H13.3062H32.1343ZM17.6683 14.0313V13.0313H16.6683H6.84215V7.00895H38.5983V13.0313H28.7721H27.7721V14.0313V41.591H17.6683V14.0313Z" stroke="#00FFFF" stroke-width="2"/>
                </svg>
            </div>

            {/* this below is the timeline div part */}
            <div className='flex flex-col justify-center items-center h-[100vh] w-auto md:pt-[50px] scale-75'>


                <div ref={date1} className={`flex flex-col justify-center items-center pb-2 ${date1IsVisible ? "slide" : ''} `}>
                    <p className="text-gray-400 text-2xl font-bold">2018</p>
                    {/* <div className='w-[10px] h-[10px] rounded-full bg-cyan-500 m-3'></div> */}
                    <div className='flex flex-col justify-center items-center border-solid border-2 border-gray-600 text-gray-400 w-[95vw] md:w-[500px] h-fit bg-opacity-10 bg-blur-md bg-gray-400 backdrop-filter backdrop-blur-md rounded-md p-3 text-xs hover:text-xl hover:text-[#DA70D6]'>
                        <p className='pb-2 text-xl font-bold'>DAV - 10th Grade</p>
                        <ol>
                        <li className='text-center'>Secured a centum in Mathematics</li>
                        <li className='text-center'>Secured 95% in CBSE boards</li>
                        <li className='text-center'>Top 3 in among school</li>
                        <li className='text-center'>Received honorary award</li>
                        </ol>

                    </div>
                </div>
                <svg width="17" height="158" viewBox="0 0 17 158" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0ZM7 8L7 158H10L10 8H7Z" fill="#00FFFF"/>
                </svg>

                <div ref={date2} className={`flex flex-col justify-center items-center pb-2 ${date2IsVisible ? "slide" : ''}`}>
                    <p className="text-gray-400 text-2xl font-bold">2020</p>
                    {/* <div className='w-[10px] h-[10px] rounded-full bg-cyan-500 m-3'></div> */}
                    <div className='flex flex-col justify-center items-center border-solid border-2 border-gray-600 text-gray-400 w-[95vw] md:w-[500px] h-fit bg-opacity-10 bg-blur-md bg-gray-400 backdrop-filter backdrop-blur-md rounded-md p-3 text-xs hover:text-xl hover:text-[#DA70D6]'>
                        <p className='pb-2 text-xl font-bold'>MVM - 12th Grade</p>
                        <ol>
                            <li className='text-center'>Among top 1% in JEE (Toughest exam in the world)</li>
                            <li className='text-center'>Top 1% in school</li>
                            <li className='text-center'>Secured 96% in CBSE boards</li>
                        </ol>
                    </div>
                </div>
                <svg width="17" height="158" viewBox="0 0 17 158" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0ZM7 8L7 158H10L10 8H7Z" fill="#00FFFF"/>
                </svg>
                <div ref={date3} className={`flex flex-col justify-center items-center pb-2 ${date3IsVisible ? "slide" : ''}`}>
                    <p className="text-gray-400 text-2xl font-bold">2023</p>
                    <div className='flex flex-col justify-center items-center border-solid border-2 border-gray-600 text-gray-400 w-[95vw] md:w-[500px] h-fit bg-opacity-10 bg-blur-md bg-gray-400 backdrop-filter backdrop-blur-md rounded-md p-3 text-xs hover:text-xl hover:text-[#DA70D6]'>
                            <p className='pb-2 text-xl font-bold'>CITI INTERN</p>
                            <ol>
                                <li className='text-center'> Reduced the manual effort involved in the checkout process for various internal applications by over 90%. Developed an efficient automation tool to perform Service Health Checks.</li>
                                <li className='text-center'> Performed data modeling on banking data.</li>

                            </ol>
                    </div>
                </div>
                <svg width="17" height="158" viewBox="0 0 17 158" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0ZM7 8L7 158H10L10 8H7Z" fill="#00FFFF"/>
                </svg>
    
                <div ref={date4} className={`flex flex-col justify-center items-center pb-2 ${date4IsVisible ? "slide" : ''}`}>
                    <p className="text-gray-400 text-2xl font-bold">2024</p>
                    {/* <div className='w-[10px] h-[10px] rounded-full bg-cyan-500 m-3'></div> */}
                    <div className='flex flex-col justify-center items-center border-solid border-2 border-gray-600 text-gray-400 w-[95vw] md:w-[500px] h-fit bg-opacity-10 bg-blur-md bg-gray-400 backdrop-filter backdrop-blur-md rounded-md p-3 text-xs hover:text-xl hover:text-[#DA70D6]'>
                        <p className='pb-2 text-xl font-bold'>SSN - UNDERGRADUATE</p>
                        <ol>
                            <li className='text-center'>UG in INFORMATION TECHNOLOGY</li>
                            <li className='text-center'>Proficiency in various CS concepts</li>
                            <li className='text-center'>Coding clubs head</li>
                            <li className='text-center'>Event Heads for national level events</li>
                        </ol>
                    </div>
                </div>


            </div>






        </div>
    )

};

export default Timeline;